import AddIcon from '@mui/icons-material/Add';
import { Box } from '@mui/material';
import { GridToolbarContainer, GridToolbarQuickFilter } from '@mui/x-data-grid-pro';

import TableBackground from 'src/assets/images/backgrounds/Table.jpg';
import Button from 'src/components/Button';

export type AddRecordButtonConfig = {
    addRecordButtonText: string;
    addRecordCallBack: () => void;
};

type CustomToolbarProps = {
    title: string;
    addRecordButtonConfig?: AddRecordButtonConfig;
};
function CustomToolbar({ title, addRecordButtonConfig }: CustomToolbarProps) {
    return (
        <GridToolbarContainer
            sx={{
                backgroundImage: `url(${TableBackground})`,
                backgroundRepeat: 'no-repeat',
                backgroundPosition: 'center',
                backgroundSize: 'cover',
                borderRadius: '16px 0px',
                // eslint-disable-next-line id-length
                p: '24px',
            }}
        >
            <Box
                sx={{
                    display: 'flex',
                    flexDirection: 'row',
                    width: '100%',
                    justifyContent: 'space-between',
                }}
            >
                <GridToolbarQuickFilter
                    data-testid={`${title ? `${title}-` : ''}search-input`}
                    sx={{
                        '& .MuiOutlinedInput-notchedOutline': {
                            borderRadius: '4px',
                            borderColor: 'border.light',
                            borderWidth: '1px',
                            borderStyle: 'solid',
                        },
                    }}
                    variant="outlined"
                    placeholder="Search Table"
                />

                {addRecordButtonConfig && (
                    <Button
                        data-testid={`${title ? `${title}-` : ''}add-record-button`}
                        label={addRecordButtonConfig.addRecordButtonText}
                        onClick={addRecordButtonConfig.addRecordCallBack}
                        startIcon={<AddIcon />}
                        variant="npi-primary"
                    />
                )}
            </Box>
        </GridToolbarContainer>
    );
}

export default CustomToolbar;
